var _rect, _path, _path2, _rect2, _rect3, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 58,
    viewBox: "0 0 100 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 99,
    height: 57,
    rx: 7.5,
    fill: "#515151",
    stroke: "#515151"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98.5 38.5V50C98.5 53.5899 95.5899 56.5 92 56.5H69.5V38.5H98.5Z",
    fill: "white",
    stroke: "#515151",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 38.5V56.5H8C4.41015 56.5 1.5 53.5899 1.5 50V38.5H30.5Z",
    fill: "white",
    stroke: "#515151",
    strokeWidth: 3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 69.5,
    y: 20.5,
    width: 29,
    height: 18,
    fill: "white",
    stroke: "#515151",
    strokeWidth: 3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 20.5,
    width: 29,
    height: 18,
    fill: "white",
    stroke: "#515151",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M92 1.5C95.5899 1.5 98.5 4.41015 98.5 8V20.5H69.5V1.5H92Z",
    fill: "white",
    stroke: "#515151",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 1.5H30.5V20.5H1.5V8C1.5 4.41015 4.41015 1.5 8 1.5Z",
    fill: "white",
    stroke: "#515151",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/creditCard.651454a051f34a31fe02bb44b1b4842b.svg";
export { ForwardRef as ReactComponent };